export const SET_LANGUAGE = "SET_LANGUAGE";
export const FETCH_ACTIVITIES = "FETCH_ACTIVITIES";
export const FETCH_FLIPBOOK_SCENES = "FETCH_FLIPBOOK_SCENES";
export const FETCH_FLIPBOOK_SCENES_WITH_VAN = "FETCH_FLIPBOOK_SCENES_WITH_VAN";
export const FETCH_FLIPBOOK_SCENES_WITHOUT_VAN = "FETCH_FLIPBOOK_SCENES_WITHOUT_VAN";
export const FETCH_HEADER = "FETCH_HEADER";
export const FETCH_ROUTES = "FETCH_ROUTES";
export const FETCH_SECTIONS = "FETCH_SECTIONS";
